import { typographyCss } from '@creditornot/cb-ingredients';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { APIErrorNotification } from 'common/components';
import scientistError from 'lottie/scientist_error.json';

type ListingManagerErrorPageProps = {
  error: unknown;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px 32px;
  align-items: center;
`;

const Header = styled.span`
  ${typographyCss.Heading3()};
`;

const ErrorNotification = styled(APIErrorNotification)`
  margin: 24px 48px;
  max-width: 600px;
  max-height: 300px;
`;

const LottiePlayer = styled(Player)`
  width: 300px;
  height: 300px;
`;

export const ListingManagerErrorPage = ({ error }: ListingManagerErrorPageProps) => {
  return (
    <Root>
      <LottiePlayer autoplay loop src={scientistError} />
      <Header>
        <FormattedMessage id="global-error-message.header" />
      </Header>
      <ErrorNotification error={error} />
    </Root>
  );
};
